import script from "./PersonalView.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalView.vue?vue&type=script&setup=true&lang=js"

import "./PersonalView.vue?vue&type=style&index=0&id=47f6d100&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47f6d100"]])

export default __exports__